import stateClass, {CHANGE_EVENT} from '../baseState';
import {indicatorsState} from '../schoolQualityIndicators/state';
import {SchoolTypesState, GROUP_CHANGE_EVENT, CHANGE_EVENT as T_CHANGE_EVENT, ENABLE_EVENT as T_ENABLE_EVENT, DISABLE_EVENT as T_DISABLE_EVENT} from '../schoolTypes/state';
//import {pieChartState, FILL_PATTERN_TOGGLE_EVENT, SELECT_PIE_INDEX} from './piechart';
import {StudentsState, ACTIVE_SCHOOL_EVENT, TOGGLE_EVENT, GROUP_TOGGLE_EVENT} from '../students/state';
//import {layerState, CHANGE_EVENT as L_CHANGE_EVENT} from './layer';
//import {km3ZonesState, TOGGLE_ACTIVE_EVENT as KM_ACTIVE_EVENT} from './km3Zones/index';
//import {DevCenterAttaState, TOGGLE_ACTIVE_EVENT as DCA_ACTIVE_EVENT} from './devCenterAtt/index';
//import {PublicTransportState, TOGGLE_EVENT as PT_TOGGLE_EVENT, INTENSITY, AVG_SPEED, FILL, SPEEDCOLORMAP, FILLSPEEDMAP} from './intensity/publicTransport';
import {SPEEDCOLORMAP} from '../mobility/reducer';

const TOGGLE_OPEN_EVENT = 'toggle_open_event';

class LegendClass extends stateClass{
	
	constructor(props) {

		super(props);

		this.name = '';
		this.data = [];
		this.open = true;
		this.fillPattern = [];

	/*	indicatorsState.on('chartKeyChange', () => {
			
			this.update(this.createIndicatorLegend(indicatorsState));
		});*/

		indicatorsState.on('chartKeyChange', this.legendHandler.bind(this));

	//	layerState.on(L_CHANGE_EVENT, this.legendHandler.bind(this));
	//	pieChartState.on(FILL_PATTERN_TOGGLE_EVENT, this.legendHandler.bind(this));
	//	StudentsState.on(GROUP_TOGGLE_EVENT, this.legendHandler.bind(this));
	//	km3ZonesState.on(KM_ACTIVE_EVENT, this.legendHandler.bind(this));
	//	DevCenterAttaState.on(DCA_ACTIVE_EVENT, this.legendHandler.bind(this));
	/*	SchoolTypesState.on(T_CHANGE_EVENT, this.schoolTypesHandler.bind(this, SchoolTypesState));
		SchoolTypesState.on(T_ENABLE_EVENT, this.schoolTypesHandler.bind(this, SchoolTypesState));
		SchoolTypesState.on(T_DISABLE_EVENT, this.disableLegend.bind(this, SchoolTypesState));
		
		StudentsState.on(TOGGLE_EVENT, this.schoolTypesHandler.bind(this, SchoolTypesState));*/
	}
	getOpen(){

		return this.open;
	}
	changeOpen(){

		if(this.open) {

			this.open = false;
		} else {

			this.open = true;
		}

		this.emit(TOGGLE_OPEN_EVENT);
	}
	disableLegend() {

		this.update([]);
	}
	legendHandler() {

		var data = [];

		var indictorsLegend = this.createIndicatorLegend(indicatorsState);
		var schoolTypesLegend = this.createSchoolTypesLegend(SchoolTypesState);
	//	var centerAttaLegend = this.createCenterAtttaLegend(DevCenterAttaState);
	//	var km3ZonesLegend = this.createKM3ZonesLegend(km3ZonesState);
	//	var pubTranspLegend = this.createPubTransp(PublicTransportState);

		if(indictorsLegend.length > 0 || schoolTypesLegend.length > 0){
			var patternLegend = this.createFillPatternLegend(data);
		} else {
			var patternLegend = [];
		}

		data = data.concat(
		//	patternLegend,
			indictorsLegend,
			schoolTypesLegend,
		//	centerAttaLegend,
		//	km3ZonesLegend,
		//	pubTranspLegend
		);

		this.update(data);
	}
	createPubTransp(state) {

	//	if(state.getActiveGroup() && state.getActiveGroup().name === AVG_SPEED) {

			var colorsData = SPEEDCOLORMAP;

			var colorsDataObj = {}
			for (var i = colorsData.length - 1; i >= 0; i--) {

				colorsDataObj[colorsData[i][0]] = colorsData[i][1];
			}

			return [
				{color: [colorsDataObj[0]], text: '0 - 25 km/h'},
				{color: [colorsDataObj[25]], text: '26 - 35 km/h'},
				{color: [colorsDataObj[35]], text: '36 - 45 km/h'},
				{color: [colorsDataObj[45]], text: '46 - 55 km/h'},
				{color: [colorsDataObj[55]], text: '>56 km/h'},
			]

	//	}

		return [];
		
	}
	createCenterAtttaLegend(DevCenterAttaState) {

		if(DevCenterAttaState.getActive()) {
			return [
				{color: '#ffffff', text: '10 min'},
				{color: '#ffffe5', text: '20 min'},
				{color: '#ffeacb', text: '30 min'},
				{color: '#fed699', text: '40 min'},
				{color: '#ffad33', text: '50 min'},
				{color: '#d98c1a', text: '60 min'},
				{color: '#b36500', text: 'vairāk nekā 60 min'},

			]
		} else {
			return [];
		}
	}

	createKM3ZonesLegend(km3ZonesState) {

		if(km3ZonesState.getActive()){
			return [
				{color: '#8e5959', text: 'Autobusu maršruti'},
				{color: '#84c3b2', text: StudentsState.getActiveSchoolsString() + ' 3km sasniedzamība'},
				{color: '#ffffff', border: '3px solid #8e5959', text: StudentsState.getActiveSchoolsString() + ' autobusu pieturas'}

			];
		} else {
			return [];
		}
	}

	createSchoolTypesLegend(SchoolTypesState){

		var colors = SchoolTypesState.getColors();
		var typeNameMap = SchoolTypesState.getTypeNameMap();

		var data = [];

	/*	if(layerState.isActive('students_by_schools')) {

			if(StudentsState.getActiveSchoolsString()){
				data.push({color: '#8aaf63', text: StudentsState.getActiveSchoolsString() + ' - skolēnu izvietojums'});
			}
		}*/

	//	if(layerState.isActive('school_types') || layerState.isActive('students_by_schools')) {
			for (var i = 0, len = colors.length; i < len; i++) {

				if( typeof typeNameMap[i+1] === 'undefined' ) {
					continue;
				}

				data.push({color: colors[i], text: typeNameMap[i+1]})
			}
	//	}

		return data;
	}

	createSchoolTypesStudentsLegend(SchoolTypesState){

		var colors = SchoolTypesState.getColors();
		var typeNameMap = SchoolTypesState.getTypeNameMap();

		var data = [];

	//	if(layerState.isActive('students_by_schools')) {

			if(StudentsState.getActiveSchoolsString()){
				data.push({color: '#8aaf63', text: StudentsState.getActiveSchoolsString() + ' - skolēnu izvietojums'});
			}
	//	}

	/*	if(layerState.isActive('school_types') || layerState.isActive('students_by_schools')) {
			for (var i = 0, len = colors.length; i < len; i++) {

				if( typeof typeNameMap[i+1] === 'undefined' ) {
					continue;
				}

				data.push({color: colors[i], text: typeNameMap[i+1]})
			}
		}*/

		return data;
	}

	createFillPatternLegend() {

		var data = [];

		if(pieChartState.fillPaternActive) {

			data.push({stripes: 'vertical', text: 'Mazākumtautību skolas'});
			data.push({stripes: 'horizontal', text: 'Divplūsmu skolas'});
		}

		return data;
	}

	getName() {
		return this.name;
	}

	createIndicatorLegend(indicatorsState) {

	//	if(!layerState.isActive('quality_indicators')) {

	//		return [];
	//	}

		console.log('createIndicatorLegend', indicatorsState);

		var group = indicatorsState.getActiveGroup();

		
		var data = [];		

		if(typeof group !== 'undefined' && typeof group.order !== 'undefined'){
			for (var i = group.order.length - 1; i >= 0; i--) {

				data.push({color: group.colors[i], text: group.order[i]});
			}
		}

			
		return data;
	}

}

var LegendState = new LegendClass();

export {LegendState, CHANGE_EVENT, TOGGLE_OPEN_EVENT};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/legend/state.js